import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ArrowUp20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M9.25012 3.81075L4.03051 9.03037L2.96985 7.96971L10.0002 0.939377L17.0305 7.96971L15.9698 9.03037L10.7501 3.81064L10.7501 19H9.25012L9.25012 3.81075Z'
      fill='currentColor'
    />
  </Svg>
);

ArrowUp20.displayName = 'ArrowUp20';
export default ArrowUp20;
